import {
	getCatalogAdapter,
	getCatalogsGoodsAdapter,
} from '@api/FW/adapters/common/catalogs.adapter';
import {  getQueryParams, httpApi } from '@api/FW/http.api';
import {
	CatalogsGoods,
	CatalogsGoodsAdapter,
	CatalogsMethod,
	CatalogAdapter,
	Catalog,
	CatalogsFuelStationsAdapter,
	CatalogsFuelStations,
} from '@interfaces/FW/common/Catalogs';

export const getCatalogs = (
	method: CatalogsMethod,
	getParams?: {},
): Promise<CatalogsGoods[] | Catalog[] | CatalogsFuelStations[]> => {
	return httpApi
		.get<CatalogsGoodsAdapter[] | CatalogAdapter[] | CatalogsFuelStationsAdapter[]>(
			`Catalogs/${method}`,
			{
				params: { ...getQueryParams(), ...getParams },
			},
		)
		.then(({ data }) => {
			if (method === CatalogsMethod.goods) {
				return getCatalogsGoodsAdapter(data as CatalogsGoodsAdapter[]);
			}

			// We're moving tovards removing catalogs.
			// if (method === CatalogsMethod.fuelstations) {
			// 	return getCatalogsFuelStationsAdapter(
			// 		data as CatalogsFuelStationsAdapter[]
			// 	)
			// }

			return getCatalogAdapter(data as CatalogAdapter[]);
		})
		.catch((err) => {
			throw err;
		});
};
